
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { useTranslation } from 'react-i18next';

const AIChatbotDocumentation = () => {
    const { t } = useTranslation();

    return (
        <div className="flex relative ">

            <main className="flex-1 px-4 sm:px-6 lg:px-8 py-8">
                <div className="max-w-4xl mx-auto">
                    {/* Header */}
                    <div className="mb-8">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">
                            {t('howToInstallConfigureAIChatbot')}
                        </h1>
                        <p className="text-xl text-gray-600">
                            {t('completeGuideAIChatbot')}
                        </p>
                    </div>

                    {/* Requisitos Previos */}
                    <section  id="requisitos" className="mb-12 scroll-mt-20">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            {t('prerequisites')}
                        </h2>
                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('beforeYouBegin')}
                            </h3>
                            <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4">
                                <li>{t('haveScannedQRCode')}</li>
                                <li>{t('haveActiveSubscription')}</li>
                                <li>{t('haveIntegrationWithBitrix24')}</li>
                            </ul>
                            <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
                                <p className="text-blue-700">
                                    <strong>{t('note')}:</strong> {t('ifNoIntegrationYet')} <Link to="/how-to-connect-with-bx24" className="text-blue-600 underline">{t('howToConnectWithBitrix24')}</Link>
                                </p>
                            </div>
                        </Card>
                    </section>

                    {/* Instalación */}
                    <section  id="instalacion" className="mb-12 scroll-mt-20">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            {t('installation')}
                        </h2>
                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('botStep1GoToAutomation')}
                            </h3>
                            <p className="text-gray-700">
                                {t('botStep1Description')}
                            </p>
                        </Card>
                        <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                            <a className="w-full cursor-pointer" href="/img/bot/1.png" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/img/bot/1.png" 
                                    alt="Installation Process"
                                    className="w-full"
                                />
                            </a>
                            <div className="bg-gray-100 px-4 py-2">
                                <p className="text-sm text-gray-600">{t('figure1Automation')}</p>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('botStep2InstallAndActivate')}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t('botStep2Description1')}
                            </p>

                            <p className="text-gray-700 mb-4">
                                {t('botStep2Description2')}
                            </p>

                            <p className="text-gray-700 ">
                                {t('botStep2Description3')}
                            </p>
                        </Card>
                        <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                            <a className="w-full cursor-pointer" href="/img/bot/2.png" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/img/bot/2.png" 
                                    alt="Bot Configuration Page"
                                    className="w-full"
                                />
                            </a>
                            <div className="bg-gray-100 px-4 py-2">
                                <p className="text-sm text-gray-600">{t('figure2BotConfigPage')}</p>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <p className="text-gray-700 ">
                                {t('ownCredentialsDescription')}
                            </p>
                        </Card>
                        <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                            <a className="w-full cursor-pointer" href="/img/bot/7.png" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/img/bot/7.png" 
                                    alt="Credenciales propias"
                                    className="w-full"
                                />
                            </a>
                            <div className="bg-gray-100 px-4 py-2">
                                <p className="text-sm text-gray-600">{t('figure3OwnCredentials')}</p>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('botStep3GoToOpenLines')}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t('botStep3Description1')}
                            </p>

                            <p className="text-gray-700 ">
                                {t('botStep3Description2')}
                            </p>
                        </Card>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                                <a className="w-full cursor-pointer" href="/img/bot/3.png" target="_blank" rel="noopener noreferrer">
                                    <img 
                                        src="/img/bot/3.png" 
                                        alt="Open Lines"
                                        className="w-full"
                                    />
                                </a>
                                <div className="bg-gray-100 px-4 py-2">
                                    <p className="text-sm text-gray-600">{t('figure4OpenLines')}</p>
                                </div>
                            </div>

                            <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                                <a className="w-full cursor-pointer" href="/img/bot/5.png" target="_blank" rel="noopener noreferrer">
                                    <img 
                                        src="/img/bot/5.png" 
                                        alt="Open Channel and permissions"
                                        className="w-full"
                                    />
                                </a>
                                <div className="bg-gray-100 px-4 py-2">
                                    <p className="text-sm text-gray-600">{t('figure5OpenChannelPermissions')}</p>
                                </div>
                            </div>
                        </div>

                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                {t('botStep4ConfigureBot')}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t('botStep4Description1')}
                            </p>

                            <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4">
                                <li>{t('botConfigSelectChatbot')}</li>
                                <li>{t('botConfigActivateChatbot')}</li>
                                <li>{t('botConfigTransferConversation')}</li>
                                <li>{t('botConfigDisconnectChatbot')}</li>
                            </ul>

                            <p className="text-gray-700">
                                {t('botStep4Description2')}
                            </p>
                        </Card>
                        <div className="rounded-lg overflow-hidden shadow-lg mb-6">
                            <a className="w-full cursor-pointer" href="/img/bot/4.png" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/img/bot/4.png" 
                                    alt="Configuración del bot en el Open Channel"
                                    className="w-full"
                                />
                            </a>
                            <div className="bg-gray-100 px-4 py-2">
                                <p className="text-sm text-gray-600">{t('figure6BotConfigOpenChannel')}</p>
                            </div>
                        </div>
                    </section>


                    {/* <section  id="webhooks" className="mb-12 scroll-mt-20">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            Configurar Webhooks
                        </h2>
                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                Configuración de endpoints
                            </h3>
                            <p className="text-gray-700 mb-4">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam ut dolor quis libero tincidunt varius. Maecenas efficitur velit vel tellus maximus convallis.
                            </p>
                            <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-4">
                                <li>Accede al panel de administración de Bitrix24</li>
                                <li>Lorem ipsum dolor sit amet consectetur</li>
                                <li>Sed do eiusmod tempor incididunt</li>
                                <li>Ut enim ad minim veniam quis</li>
                                <li>Duis aute irure dolor in reprehenderit</li>
                            </ol>
                            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4">
                                <p className="text-yellow-700">
                                    <strong>Advertencia:</strong> Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim.
                                </p>
                            </div>
                        </Card>
                        <Card className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-800 mb-3">
                                Video Tutorial: Configuración de Webhooks
                            </h3>
                            <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center mb-4">
                                <video
                                    controls        // play / pause / volumen
                                    muted
                                    src='/video/test.mp4'
                                    playsInline
                                />
                            </div>
                        </Card>
                    </section> */}


                    <div className="mt-12 pt-8 border-t border-gray-200">
                        <p className="text-center text-gray-500 text-sm">
                            {t('lastUpdated')}
                        </p>
                    </div>
                </div>
            </main>
        </div>
    );
}
 
export default AIChatbotDocumentation;